import { Outlet } from "react-router-dom";

import SiteFooter from "@/components/layout/SiteFooter";
import SiteHeader from "@/components/layout/SiteHeader";

/**
 * 공개 사이트(랜딩/연구소개/기관/연구성과) 공용 레이아웃 셸.
 * 인증이 필요 없는 라우트 그룹(`PublicRoute`)의 부모 레이아웃으로,
 * 공용 헤더/푸터 사이에 각 페이지를 `Outlet`으로 렌더한다.
 */
export default function PublicLayout() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <SiteHeader />
      <Outlet />
      <SiteFooter />
    </div>
  );
}
